





















import Vue from 'vue';
import SelectRemarkBox from '@/customer/components/remarks/SelectRemarkBox.vue';
import CustomerRemark from '../../models/CustomerRemark';
import customerClient from '@/customer/apis';

export default Vue.extend({
  components: {
    SelectRemarkBox,
  },
  data() {
    return {
      remarkIds: [] as Array<number>,
      showNameBox: false,
      showRemarkBox: false,
      groupName: '',
    }
  },
  methods: {
    handleAddBtn(): void {
      this.showNameBox = true;
    },
    handleConfirmName(): void {
      this.showNameBox = false;
      this.showRemarkBox = true;
    },
    handleCancelName(): void {
      this.showNameBox = false
    },
    handleConfirmRemarks(remarks: Array<CustomerRemark>): void {
      this.remarkIds = remarks.map(t => t.id);
      customerClient.createRemarkGroup({
        remarkIds: this.remarkIds,
        name: this.groupName,
      }).success(() => {
        this.$emit('created');
        this.showRemarkBox = false;
      }).failure((code) => {
        let msg = '更新失败';
        if(code === 'NameConflict') {
          msg = '标签组名称已存在';
        }
        this.$Message.error(msg);
        this.showRemarkBox = false;
      });
    },
  },
});
